// css

const colors = {
  mainColor: "#511d00",
  secondaryColor: "#52A892",
  mainThemeClr: "#FAF9F6",
};

exports.colors = colors;
